"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _default = exports.default = {
  components: {
    UserAvatar: _UserAvatar.default
  },
  props: ['network'],
  data: function data() {
    return {
      is_usermenu_open: false
    };
  },
  computed: {
    getUser: function getUser() {
      if (this.network && this.network.state && this.network.currentUser()) {
        return this.network.currentUser();
      }
      return null;
    },
    isConnected: function isConnected() {
      return this.network && this.network.state === 'connected';
    }
  },
  methods: {
    clickForget: function clickForget() {
      var msg = 'This will delete all stored networks and start fresh. Are you sure?';
      /* eslint-disable no-restricted-globals, no-alert */
      var confirmed = confirm(msg);
      if (!confirmed) {
        return;
      }
      this.$state.persistence.forgetState();
      window.location.reload();
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserUsermenu"]
window._kiwi_exports.components.StateBrowserUsermenu = exports.default ? exports.default : exports;
